"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _subHeading = _interopRequireDefault(require("@audacious/components/lib/components/typography/sub-heading"));

var _grid = require("@audacious/components/lib/components/grid");

var _button = _interopRequireDefault(require("@audacious/components/lib/components/button"));

var _simpleTable = _interopRequireDefault(require("@audacious/components/lib/components/table/simple/simple-table"));

var _tableMessage = _interopRequireDefault(require("@audacious/components/lib/components/table-message"));

var _text = _interopRequireDefault(require("@audacious/components/lib/components/text"));

var _page = require("@audacious/components/lib/components/page");

var _spinner = _interopRequireDefault(require("@audacious/components/lib/components/spinner"));

var _faFileCsv = require("@audacious/icons/regular/faFileCsv");

var _uploadPanelDrawer = _interopRequireDefault(require("./upload-panel-drawer"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_spinner.default, {
  id: "panel-spinner",
  variant: "overlay",
  spaceFromTop: "sm"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_grid.Column, {
  width: "fill"
}, /*#__PURE__*/_react.default.createElement(_subHeading.default, {
  id: "missing-persons-panel-header",
  level: "5"
}, "Missing Persons Panel"));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_tableMessage.default, {
  header: "No panels to display."
});

var Panels = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Panels, _React$Component);

  var _super = _createSuper(Panels);

  function Panels(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Panels);
    _this = _super.call(this, props);
    _this.state = {
      showUploadDrawer: false
    };
    _this.handleUploadPanelClick = _this.handleUploadPanelClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUploadDrawerClose = _this.handleUploadDrawerClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDownloadPanelClick = _this.handleDownloadPanelClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.COLUMNS = [{
      headerBody: 'Panel Name',
      cellValuePath: 'panelName',
      cellFilterPath: 'panelName',
      renderCell: function renderCell(cellValue) {
        return /*#__PURE__*/_react.default.createElement(_text.default, {
          size: "lg",
          weight: "semi-bold"
        }, cellValue);
      }
    }, {
      headerBody: 'Created By',
      cellValuePath: 'createdBy',
      cellFilterPath: 'createdBy',
      renderCell: function renderCell(cellValue) {
        return /*#__PURE__*/_react.default.createElement(_text.default, {
          size: "lg",
          weight: "semi-bold"
        }, cellValue);
      }
    }, {
      headerBody: 'Date Uploaded',
      cellValuePath: 'dateUploaded',
      cellFilterPath: 'dateUploaded',
      renderCell: function renderCell(cellValue) {
        var formattedTime = (0, _moment.default)(cellValue).format('MM/DD/YYYY, h:mm a');
        return formattedTime;
      }
    }, {
      headerBody: 'Current Panel',
      cellValuePath: 'mp_list_id',
      width: '170px',
      // eslint-disable-next-line camelcase
      renderCell: function renderCell(mp_list_id) {
        return /*#__PURE__*/_react.default.createElement(_button.default, {
          color: "primary",
          variant: "none",
          leftIcon: _faFileCsv.faFileCsv,
          size: "2xs",
          onClick: _this.handleDownloadPanelClick // eslint-disable-next-line camelcase
          ,
          onClickMeta: mp_list_id
        }, "Download");
      }
    }];
    return _this;
  }

  (0, _createClass2.default)(Panels, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var service = this.context.service;
      service.missingPersons.getAllPanels();
    }
  }, {
    key: "handleUploadPanelClick",
    value: function handleUploadPanelClick() {
      this.setState({
        showUploadDrawer: true
      });
    }
  }, {
    key: "handleUploadDrawerClose",
    value: function handleUploadDrawerClose() {
      this.setState({
        showUploadDrawer: false
      });
    }
  }, {
    key: "handleDownloadPanelClick",
    value: function handleDownloadPanelClick(_ref) {
      var meta = _ref.meta;
      var service = this.context.service;
      var panelId = meta;
      service.missingPersons.getPanelDetails({
        options: {
          panelId: panelId
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var showUploadDrawer = this.state.showUploadDrawer;
      var _this$props = this.props,
          panels = _this$props.panels,
          loadingPanels = _this$props.loadingPanels;

      if (loadingPanels) {
        return _ref2;
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_page.PageContainerGroup, null, /*#__PURE__*/_react.default.createElement(_grid.Row, {
        className: "home-content-header",
        gutter: "24",
        enableAfter: true
      }, _ref3, /*#__PURE__*/_react.default.createElement(_grid.Column, {
        width: "content"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        id: "upload-new-panel-button",
        variant: "outline",
        color: "primary",
        onClick: this.handleUploadPanelClick
      }, "Upload New Panel")))), /*#__PURE__*/_react.default.createElement(_simpleTable.default, {
        id: "panels-table",
        items: panels,
        columns: this.COLUMNS,
        minWidth: 800,
        alwaysShowHeaders: true,
        pageTable: true,
        useParentScroll: true,
        stickyColumns: 1
      }), panels.length === 0 ? _ref4 : null, /*#__PURE__*/_react.default.createElement(_uploadPanelDrawer.default, {
        open: showUploadDrawer,
        onClose: this.handleUploadDrawerClose
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Panels;
}(_react.default.Component);

Panels.contextTypes = {
  service: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]))
};
Panels.defaultProps = {
  panels: []
};
var _default = Panels;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Panels, "Panels", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/panels/panels.jsx");
  reactHotLoader.register(_default, "default", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/panels/panels.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();